export const BUSINESS_PLUS_PLANS = ['BUSINESS_PLUS_M', 'BUSINESS_PLUS_Y', 'BUSINESS_PLUS_F_Y', 'AGENCY', 'AGENCY_Y', 'E_BUSINESS', 'E_BUSINESS_Y']
export const BUSINESS_PLANS = ['ESTAGE_SUB', 'BUSINESS_Y', 'STARTER', 'STARTER_Y']
export const ANNUAL_PLANS = ['BUSINESS_PLUS_Y', 'BUSINESS_Y']
